import { Component } from '@angular/core';

@Component({
  selector: 'app-large-content',
  templateUrl: './large-content.component.html',
  styleUrls: ['./large-content.component.scss']
})
export class LargeContentComponent {
}

